import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretLeftStopIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 13.5 14.5",
	style: { enableBackground: "new 0 0 13.5 14.5" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.caret-left-stop-st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n	.caret-left-stop-st2{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "caret-left-stop-st1",
		d: "M12.5,13.5L6.2,7.2L12.4,1"
	}), /* @__PURE__ */ _jsx("line", {
		className: "caret-left-stop-st2",
		x1: 1,
		y1: 1.2,
		x2: 1,
		y2: 13.2
	})] })]
});
export default SvgCaretLeftStopIcon;
